import { styled } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';

export const SublimitsFiltersContainer = styled(Card)(({ theme }) => ({
  '& > [role=vertical-tab-wrapper] > .MuiBox-root > [role=tab-panel] > .MuiBox-root': {
    padding: 0,
    overflowX: 'auto'
  },
  '& .MuiTab-labelIcon': {
    paddingInline: 0,
    borderRadius: theme.spacing(1)
  }
}));
